import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["ExpandButton", "CollapseButton", "H85AwaitingShippingAvailableContainer"]

  connect() {
    this.element[this.identifier] = this
  }

  expand(e) {
    this.ExpandButtonTarget.classList.add("hidden")
    this.CollapseButtonTarget.classList.remove("hidden")
    this.H85AwaitingShippingAvailableContainerTarget.classList.remove("hidden")
  }

  collapse(e) {
    this.ExpandButtonTarget.classList.remove("hidden")
    this.CollapseButtonTarget.classList.add("hidden")
    this.H85AwaitingShippingAvailableContainerTarget.classList.add("hidden")
  }

}
